/**
 * Reusable schema.org JSON-LD builders. Pass returned objects into
 * <SEO jsonLd={...} /> on each page.
 */

const SITE = 'https://salonvora.com'

export const breadcrumb = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: it.name,
    item: it.url.startsWith('http') ? it.url : `${SITE}${it.url}`,
  })),
})

export const service = ({ name, description, slug, price, currency = 'INR' }) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name,
  description,
  provider: { '@id': `${SITE}/#organization` },
  areaServed: 'Chennai',
  url: `${SITE}/services/${slug}`,
  ...(price && {
    offers: { '@type': 'Offer', price, priceCurrency: currency, availability: 'https://schema.org/InStock' },
  }),
})

export const faq = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: items.map((q) => ({
    '@type': 'Question',
    name: q.question,
    acceptedAnswer: { '@type': 'Answer', text: q.answer },
  })),
})

export const article = ({ title, description, slug, image, datePublished, dateModified, authorName }) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: title,
  description,
  image: image.startsWith('http') ? image : `${SITE}${image}`,
  datePublished,
  dateModified: dateModified || datePublished,
  author: { '@type': 'Person', name: authorName || 'Salon Vora Editorial' },
  publisher: {
    '@type': 'Organization',
    name: 'Salon Vora',
    logo: { '@type': 'ImageObject', url: `${SITE}/brand/logo.jpg` },
  },
  mainEntityOfPage: `${SITE}/blog/${slug}`,
})

export const localBusinessReview = ({ rating, count }) => ({
  '@context': 'https://schema.org',
  '@type': 'BeautySalon',
  '@id': `${SITE}/#organization`,
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: rating,
    reviewCount: count,
  },
})
